import { Text } from '@chakra-ui/react'
import React from 'react'
import Highlighter from 'react-highlight-words'

interface MarkerProps {
  bgColor?: string
  border?: string
  color?: string
}

export const Marker: React.FC<MarkerProps> = ({
  bgColor,
  border = 'none',
  children,
  color = 'blue.50',
}) => (
  <Text as="span" bgColor={bgColor} border={border} color={color}>
    {children}
  </Text>
)

interface TextHighlightProps {
  children: string
  component?: React.ComponentClass | React.FunctionComponent
  search?: string | string[]
}

export const TextHighlight = ({
  children,
  search,
  component = Marker,
}: TextHighlightProps) =>
  search ? (
    <Highlighter
      autoEscape
      highlightTag={component}
      searchWords={typeof search === 'string' ? [search] : search}
      textToHighlight={children}
    />
  ) : (
    <>{children}</>
  )
